import { handleActions } from 'redux-actions-helpers';
import { check, uncheck, resetCheck, updateCountEvents } from './actions';

export const initialState = {
    eventsCount: 0,
    items      : {}
};

export default handleActions({
    [check]: (state, { kind, sport, tournament, totalCountTournaments }) => {
        const { gameId } = sport;

        if(kind === 'tournaments') {
            const { _id } = tournament;

            return {
                ...state,
                items: {
                    ...state.items,
                    [gameId]: Array.isArray(state.items[gameId]) ? [...state.items[gameId], _id] : [_id]
                },
                eventsCount: state.eventsCount + tournament.total

            }
        } else {
            return {
                ...state,
                items: {
                    ...state.items,
                    [gameId]: {}
                },
                eventsCount: kind === 'sports' ? state.eventsCount + sport.qty : totalCountTournaments
            }
        }
    },
    [uncheck]: (state, { kind, globalTournaments, sport, tournament }) => {
        const items = state.items;
        const { gameId, qty } = sport;

        if(kind === 'tournaments') {
            const { _id } = tournament;
            const count = state.eventsCount - tournament.total;
            let tournaments = [];

            if(!Array.isArray(state.items[gameId])) {
                tournaments = globalTournaments[gameId].filter((tournament) => tournament._id !== _id).map((item) => item._id);
            } else {
                tournaments = items[gameId].filter((item) => item !== _id);
            }

            if(tournaments.length) {
                return {
                    ...state,
                    items: {
                        ...state.items,
                        [gameId]: tournaments
                    },
                    eventsCount: count
                }
            }

            delete items[gameId];

            return {
                items: {
                    ...state.items,
                    ...items
                },
                eventsCount: count
            }
        } else {
            let totalTournaments = 0;

            if(Array.isArray(state.items[gameId])) {
                totalTournaments = globalTournaments[gameId]
                    .reduce((result, current) => {
                        if(state.items[gameId].includes(current._id)) {
                            return result + current.total;
                        }

                        return result;
                    }, 0);
            } else {
                totalTournaments = qty
            }

            delete items[gameId];

            return {
                ...state,
                items: {
                    ...state.items,
                    ...items
                },
                eventsCount: kind === 'allSports' ? 0 : state.eventsCount - totalTournaments
            }
        }
    },
    [updateCountEvents]: (state, { sports, tournaments }) => {
        const items = state.items;
        let count = 0;

        sports.forEach((sport) => {
            if(items[sport.gameId]) {
                if(!Array.isArray(items[sport.gameId])) {
                    count += sport.qty
                } else {
                    tournaments[sport.gameId].forEach((tournament) => {
                        if(items[sport.gameId].includes(tournament._id)) {
                            count += tournament.total
                        }
                    })
                }
            }

            return count
        });

        return {
            ...state,
            eventsCount: count
        };
    },
    [resetCheck]: () => {
        return initialState;
    }
}, { initialState });



// WEBPACK FOOTER //
// ./src/blocks/checked/reducer.js